import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { EventsMutationKeys } from '../../../keys'
import { UpdateEventRequest, UpdateEventResponse } from '../../../type'
import { updateEvent } from '../../services'

interface UpdateEventParams {
	id: string
	payload: UpdateEventRequest
}

export default function useMutationUpdateEvent(
	props?: UseBaseMutationOptions<UpdateEventResponse, UpdateEventParams>,
) {
	return useMutation({
		mutationKey: [EventsMutationKeys.updateEvent],
		mutationFn: (params) => updateEvent(params.id, params.payload),
		...props,
	})
}
